import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "hideable" ]

  connect() {
    super.connect();
    this.showOrHideTargets();
  }

  showTargets() {
    this.hideableTargets.forEach(el => {
      this.showTarget(el)
    });
  }

  showTarget(el) {
    el.hidden = false
    el.classList.remove('hidden')
  }

  hideTargets() {
    this.hideableTargets.forEach(el => {
      this.hideTarget(el)
    });
  }

  hideTarget(el) {
    el.hidden = true
    el.classList.add('hidden')
  }

  toggle() {
    this.hideableTargets.forEach(el => {
      el.hidden = !el.hidden
      el.classList.toggle('hidden')
    });
  }

  showOrHideTargets() {
    this.hideableTargets.forEach(el => {
      if (el.dataset.hiddenInitial === 'false') {
        this.showTarget(el)
      } else {
        if (el.dataset.hiddenInitial != null) {
          this.hideTarget(el)
        }
      }
    });
  }
}
